import React, { useEffect, useState } from "react";
import style from "../solo.module.sass";
import ArrowCloseSvg from '../../../../../assets/svg/solo/arrowClose_ico.svg';
import ArrowOpenSvg from '../../../../../assets/svg/solo/arrowOpen_ico.svg';
import { Select, Icon } from "antd";
import { useSelector } from "react-redux";
import publicIcon from "../../../../../assets/svg/solo/public_col_ico.svg"
const { Option } = Select;

const WidgetIconsView = (props: any) => {
    const selectedAppType = useSelector(
      (state: any) => state.apps.selectedApp.type
    );
    const onDragStart = (event: any, nodeType: any) => {
        event.dataTransfer.setData('application/reactflow', nodeType);
        event.dataTransfer.effectAllowed = 'move';
    };
    const selectedSoloInfo = useSelector((state: any) => state.solo.selectedSolo);
    const [widgetDrawer, setWidgetDrawer]: any = useState(false);
    const [selectAuthFlow, setSelectAuthFlow]: any = useState(null);
    const [widgetIconHover, setWidgetIconHover]: any = useState(null);

    useEffect(() => {
        if (props.selectedAuthFlow) {
            setSelectAuthFlow(props.selectedAuthFlow)
        }
    }, [props.selectedAuthFlow])
    return (
        <div className={style.left_menu} style={{ left: widgetDrawer ? 0 : -190, background: widgetDrawer ? '#FFF' : '#E6EFFF' }}>
            {widgetDrawer ? <div>
                {selectedSoloInfo && selectedSoloInfo.type === "private" && <div className={style.authflow}>
                    <label>Select Auth Flow</label>
                    <Select
                        className="dd"
                        suffixIcon={<Icon style={{ fontSize: "20px", margin: -5 }} type="caret-down" />}
                        disabled={props.lock}
                        placeholder="Select Auth Flow"
                        defaultValue={selectAuthFlow || undefined}
                        style={{ width: "100%", color: "#657695", fontSize: 13 }}
                        onChange={(e: any) => { setSelectAuthFlow(e); props.onSelectedAuthFlow(e) }}
                    >
                        {props.solo && props.solo.flows.map((s: any) => {
                            return ((s.type === "public" && props.id !== s.id) &&
                                <Option key={s.name} value={s.name}>
                                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                        <img alt="pubicIcon" src={publicIcon} />
                                        <div style={{ marginLeft: "4px" }}>{s.name}</div>
                                    </div>
                                </Option>
                            )
                        })}
                    </Select>
                </div>}
                <div className={style.header}>
                    <label style={{ margin: 0 }}>
                        Widgets
                    </label>
                    <img alt="closeArrow" src={ArrowCloseSvg} onClick={() => { setWidgetDrawer(false) }} />
                </div>
                <div className={style.widgets} style={{ maxHeight: selectedSoloInfo && selectedSoloInfo.type === "private" ? "calc(100vh - 250px)" : "calc(100vh - 150px)" }}>
                    {props.icons && props.icons.map((item: any) => {
                        if((item.type === "liveAgent" || item.type === "message") && selectedAppType !== "a8chat") {
                            return null
                        }
                        return item.type !== "start" && <div onDragStart={(event) => onDragStart(event, JSON.stringify(item))} draggable key={item.type} className={style.item} onMouseEnter={() => { setWidgetIconHover(item.type) }} onMouseLeave={() => { setWidgetIconHover(null) }}>
                            <div className={style.icon} style={{ borderColor: item.type === widgetIconHover ? item.color : '#CAD5E9' }}>
                                {item.icon && <img alt="icon" src={item.icon} />}
                            </div>
                            <div className={style.title}>
                                {item.label}
                            </div>
                        </div>
                    })}
                </div>
            </div> : <div className={style.open} onClick={() => { setWidgetDrawer(true) }} >
                <img alt="openArrow" src={ArrowOpenSvg} />
            </div>}
        </div>
    );
}

export default WidgetIconsView;